// @flow
import * as React from 'react';
import StatusSelect from 'components/StatusSelect';
// import ListingStatusLabel from 'components/ListingStatusLabel';
import { updateObject } from 'utils/functional';
import { APPLICATION_STATUSES } from 'utils/constants/ats';
import Field from './Field';

const STATUS_OPTIONS = Object.keys(APPLICATION_STATUSES).map(k => ({
  value: k,
  label: APPLICATION_STATUSES[k]
}));

const StatusSelectField = ({
  name,
  label,
  description,
  options = STATUS_OPTIONS,
  onChange,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  options?: Array<{ value: string, label: string }>,
  onChange: Function
}) => (
  <Field
    inputProps={updateObject(props, { options })}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <StatusSelect
        id={id}
        name={name}
        value={value}
        options={options}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={({ value: v }) => {
          if (v !== value) {
            updateValue(v);
            if (onChange) {
              onChange(v);
            }
          }
        }}
        label={label}
        {...props}
      />
    )}
  />
);

export default StatusSelectField;
